<template>
  <div class="bg-grey-lines block-fullscreen">
    <div class="header-logo">
      <icon name="td-logo" color="#393f49" />
    </div>
    <section class="block-fullscreen-center">
      <questions title="Cliente" :items='questions' :key-form='keyForm'
        prev="/processos/formulario" next="/estrategia" />
    </section>
  </div>
</template>

<script>
import Icon from './Icon';
import Questions from './Questions';

/* eslint-disable max-len */
export default {
  name: 'customer-form',
  components: { Icon, Questions },
  data() {
    return {
      keyForm: 'customer_experience',
      questions: [
        { field: 'td_cust_understanding', title: 'Entendendo os hábitos de consumo dos clientes, minha empresa redesenhou - ou adaptou - a jornada de compra com foco na experiência do consumidor. ' },
        { field: 'td_cust_focus', title: 'A experiência do consumidor é o foco em todos os pontos de contato entre a empresa e seus consumidores.' },
        { field: 'td_cust_data', title: 'A empresa coleta resultados e retornos dos seus clientes através de plataformas digitais.' },
        { field: 'td_biz_model', title: 'A empresa pensa em investir em novos modelos de negócio ou mesmo adaptar o atual ao digital.' },
        { field: 'td_tech_adoption', title: 'A empresa utiliza a tecnologia constantemente para melhoria do seu produto e inovação contínua da sua entrega.' },
        { field: 'td_experimentation', title: 'A empresa busca aplicar o Test and Learning - ou seja, testar mudanças, “falhar rápido” e aprender com o que foi testado para otimizar em seguida.' },
        { field: 'td_digital_delivery', title: 'A empresa oferece a entrega parcial ou integral de seus produtos / serviços através de plataformas digitais.' },
      ],
    };
  },
  mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 4);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CustomerForm.vue